import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const SelectableCard = ({children, isSelected = false, onSelect, style = {}, className = '', disabled = false}) => {
    return (
        <div
            /* the space matters: without it a card given both disabled and a
               className of its own came out as class="disabledmy-card", and
               neither rule applied */
            className={`selectable-card ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ` + className}
            onClick={onSelect}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onSelect()}
            style={style}
        >
            {children}
        </div>
    );
};

SelectableCard.propTypes = {
    children: PropTypes.node,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func
};

export default SelectableCard;



// WEBPACK FOOTER //
// ./src/components-new/general/SelectableCard/index.jsx